<template>
    <div>
        <div class="modal fade" id="fundproject" tabindex="-1" aria-labelledby="fundproject" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title title-modal" id="addCoach">Fund Project</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="form-group selected-option">
                            <label for="amount">Enter Amount (₦)</label>
                            <input type="number" class="form-control inputt" id="amount" placeholder="Enter first name">
                        </div>
                        
                    </div>

                    <div class="container">
                        <div class="amount-options">
                            <button class="btn">₦10,000</button>
                            <button class="btn">₦20,000</button>
                            <button class="btn">₦30,000</button>
                        </div>
                        <div class="amount-options">
                            <button class="btn">₦40,000</button>
                            <button class="btn">₦50,000</button>
                            <button class="btn">₦60,000</button>
                        </div>
                    </div>
        
                    <div class="form-group button-class container">
                        <button class="btn primaryBtn w-100">
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    components: {
        PageLoader,
    },
    // props: {
    //     // Receive the data snapshot passed from parent
    //     projectData: {
    //         type: Object,
    //         required: true
    //     }
    // },

    data() {
        return {
            progressPercent: 50,
        };
    },
    created() {

    },
    mounted() {
        // console.log("Prject details in modal:", this.projectData)
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
    }
};
</script>

<style lang="scss" scoped> 
.button-class {
    margin-bottom: 50px;
    .primaryBtn {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        height: 45px;
        outline: 0;
        box-shadow: none;
    }
}

.selected-option {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #1A1A1A;
        text-align: left;
        display: flex;

    }
    input, select {
        padding: 10px;
        border: 1px solid #E6E9EC;
        cursor: pointer;
        // display: flex;
        // align-items: center;
        // gap: 10px;
        background: #fff;
        border-radius: 4px;
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        box-shadow: none;
        outline: 0;
        height: 45px;
    }
}

.amount-options {
    button {
        background: #F8F9FA;
        color: #555555;
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        border-radius: 4px;
        height: 45px;
        margin: 10px 4px;
        outline: 0;
        box-shadow: none;
    }
    button:hover {
        background: #c8c9c9;
        border: 1px solid #c8c9c9;
    }
}

</style>